<template>
  <div class="statistics container">
    <div class="top_info">
      <div class="title">学情统计</div>
      <div class="class_info">
        <span>班级：{{ classInfo.name }}</span>
        <span>团队数：{{ classInfo.teamCount }}个</span>
        <span>学生数：{{ classInfo.studentCount }}人</span>
      </div>
    </div>
    <div class="main">
      <div class="course_info">
        <p class="info_title">课程概况</p>
        <div class="content">
          <p>{{ $route.query.chapterTitle }}</p>
        </div>
      </div>
      <div class="data">
        <p class="data_title">学情统计</p>
        <div class="one">
          <p>微课</p>
          <el-progress
            type="circle"
            :stroke-width="12"
            :percentage="statisticsinfo.videoRate"
          ></el-progress>
        </div>
        <div class="one">
          <p>课件</p>
          <el-progress
            type="circle"
            :stroke-width="12"
            :percentage="statisticsinfo.pptRate"
          ></el-progress>
        </div>
        <div class="one">
          <p>测试</p>
          <el-progress
            type="circle"
            :stroke-width="12"
            :percentage="statisticsinfo.testRate"
          ></el-progress>
        </div>
        <div
          class="one"
          v-show="statisticsinfo.szRate || statisticsinfo.szRate == 0"
        >
          <p>实战</p>
          <el-progress
            type="circle"
            :stroke-width="12"
            :percentage="statisticsinfo.szRate"
          ></el-progress>
        </div>
        <div
          v-show="
            statisticsinfo.worksScoredRate ||
            statisticsinfo.worksScoredRate == 0
          "
          class="one workScore"
          @click="
            $router.push({
              path: '/courseDetail/works',
              query: {
                ...$route.query,
                marked: false,
              },
            })
          "
        >
          <p>完成作品评分</p>
          <el-progress
            type="circle"
            :stroke-width="12"
            :percentage="statisticsinfo.worksScoredRate"
          ></el-progress>
        </div>

        <!-- <div class="one">
          <p>随堂练习</p>
          <el-progress
            type="circle"
            :stroke-width="12"
            :percentage="(info.lianxi / info.studentNum).toFixed(2) * 100"
            :format="(percentage) => format(percentage, info.lianxi)"
          ></el-progress>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { chapterStatistics } from "@/api/chapter";
import { classInfo } from "@/api/class";
export default {
  props: {
    info: Object,
  },
  data() {
    return {
      classInfo: {},
      statisticsinfo: {},
    };
  },
  created() {
    this.getClassInfo();
    this.getStatistics();
  },
  methods: {
    // 班级信息
    getClassInfo() {
      classInfo(this.$route.query.id).then((res) => {
        if (res.code == 0) {
          // console.log(res);
          this.classInfo = res.data;
        } else {
          console.log(res.msg);
        }
      });
    },
    getStatistics() {
      this.$loading.show();
      chapterStatistics(this.$route.query.classChapterId).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.statisticsinfo = res.data;
        } else {
          console.log(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.statistics {
  padding-top: 20px;
  height: 100%;
  .top_info {
    .title {
      padding: 5px;
      color: #fff;
      font-size: 18px;
      background-color: #409eff;
    }
    .class_info {
      padding: 5px;
      color: #409eff;
      font-size: 16px;
      border: solid 1px #409eff;
      span {
        margin-right: 20px;
      }
    }
  }
  .main {
    height: calc(100% - 67px - 20px);
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 4px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      border-radius: 10px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      background-color: #c8c8c8;
    }

    .course_info {
      margin-top: 30px;
      padding: 20px;
      text-align: left;
      border: solid 1px #409eff;
      border-radius: 8px;
      .info_title {
        color: #409eff;
        font-size: 16px;
      }
      .content {
        margin-top: 10px;
        padding: 10px;
        background-color: rgb(226, 236, 248);
        p {
          color: #333;
          line-height: 1.5;
        }
      }
    }

    .data {
      margin-top: 30px;
      padding: 20px;
      text-align: left;
      border: solid 1px #409eff;
      border-radius: 8px;
      .data_title {
        margin-bottom: 30px;
        color: #409eff;
        font-size: 16px;
      }
      .one {
        display: inline-block;
        margin: 0 50px;
        width: 125px;
        text-align: center;
        &.workScore {
          cursor: pointer;
        }
        p {
          margin-bottom: 20px;
          font-size: 16px;
        }
      }
    }
  }
}
</style>